import {
  AnalyticsAlertStatusType,
  AnalyticsAlertType,
  ChurnRiskHubCardData,
  HubCardType,
  LostItemHubCardData,
  OverduePaymentHubCardData,
} from '@/types';
import {
  BOBS_BURGER_SHACK_CHAT_UUID,
  BOBS_BURGER_SHACK_RESTAURANT_UUID,
  BRONCO_DEMO_CHATS,
  BRONCO_DEMO_RESTAURANT_META,
  BRONCO_SUPPLIER_UUID,
  GENERAL_NUTRITION_CHAT_UUID,
  GENERAL_NUTRITION_RESTAURANT_UUID,
  GOURMET_ICE_CREAM_CHAT_UUID,
  GOURMET_ICE_CREAM_RESTAURANT_UUID,
  GRILL_110_CHAT_UUID,
  GRILL_110_RESTAURANT_UUID,
  JOHNS_SEAFOOD_HOUSE_CHAT_UUID,
  JOHNS_SEAFOOD_HOUSE_RESTAURANT_UUID,
  RYANS_RIPPIN_RESTAURANT_CHAT_UUID,
  RYANS_RIPPIN_RESTAURANT_RESTAURANT_UUID,
  SFF_SUPPLIER_UUID,
  SPECIALTY_GOODS_CHAT_UUID,
  SPECIALTY_GOODS_RESTAURANT_UUID,
  THE_DUCK_INN_CHAT_UUID,
  THE_DUCK_INN_RESTAURANT_UUID,
  THE_SURF_CLUB_RESTAURANT_CHAT_UUID,
  THE_SURF_CLUB_RESTAURANT_RESTAURANT_UUID,
  TINA_TUNA_CHAT_UUID,
  TINA_TUNA_RESTAURANT_UUID,
} from '@/mocks/uuids';
import {
  ChurnRiskAlert,
  LostItemAlert,
  OverduePaymentAlert,
} from '@/components/dsr-analytics/types';
import { createTranslation } from '@/utils/i18n';
import { HubCardData, SalesAlertsHubCardData } from './insights-hub/types';
import { mockAlertsData } from '@/mocks/dsr-analytics/data';
import { v4 as uuidv4 } from 'uuid';

export const dummyOverduePayments: SalesAlertsHubCardData = {
  cardData: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_uuid: uuidv4(),
      amount: (
        mockAlertsData[
          THE_SURF_CLUB_RESTAURANT_CHAT_UUID
        ][0] as OverduePaymentAlert
      ).data[0].amount,
      card_type: HubCardType.OverduePayment,
      chat_uuid: THE_SURF_CLUB_RESTAURANT_CHAT_UUID,
      currency_code: 'USD',
      description: (
        mockAlertsData[
          THE_SURF_CLUB_RESTAURANT_CHAT_UUID
        ][0] as OverduePaymentAlert
      ).subtitle,
      invoice_number: (
        mockAlertsData[
          THE_SURF_CLUB_RESTAURANT_CHAT_UUID
        ][0] as OverduePaymentAlert
      ).data[0].invoice_number,
      order_invoice_uuid: (
        mockAlertsData[
          THE_SURF_CLUB_RESTAURANT_CHAT_UUID
        ][0] as OverduePaymentAlert
      ).data[0].order_invoice_uuid,
      overdue_by_text: (
        mockAlertsData[
          THE_SURF_CLUB_RESTAURANT_CHAT_UUID
        ][0] as OverduePaymentAlert
      ).subtitle,
      restaurant_uuid: THE_SURF_CLUB_RESTAURANT_RESTAURANT_UUID,
      subtitle: createTranslation(
        '120 Sir Francis Drake Blvd, San Anselmo, CA 94960, USA',
      ),
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: createTranslation('The Surf Club'),
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_uuid: uuidv4(),
      amount: (mockAlertsData[THE_DUCK_INN_CHAT_UUID][0] as OverduePaymentAlert)
        .data[0].amount,
      card_type: HubCardType.OverduePayment,
      chat_uuid: THE_DUCK_INN_CHAT_UUID,
      currency_code: 'USD',
      description: (
        mockAlertsData[THE_DUCK_INN_CHAT_UUID][0] as OverduePaymentAlert
      ).subtitle,
      invoice_number: (
        mockAlertsData[THE_DUCK_INN_CHAT_UUID][0] as OverduePaymentAlert
      ).data[0].invoice_number,
      order_invoice_uuid: (
        mockAlertsData[THE_DUCK_INN_CHAT_UUID][0] as OverduePaymentAlert
      ).data[0].order_invoice_uuid,
      overdue_by_text: (
        mockAlertsData[THE_DUCK_INN_CHAT_UUID][0] as OverduePaymentAlert
      ).subtitle,
      restaurant_uuid: THE_DUCK_INN_RESTAURANT_UUID,
      subtitle: createTranslation(
        '120 Sir Francis Drake Blvd, San Anselmo, CA 94960, USA',
      ),
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: createTranslation('The Duck Inn'),
    },
  ],
  cardType: HubCardType.OverduePayment,
};

export const dummyLostItems: SalesAlertsHubCardData = {
  cardData: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_uuid: uuidv4(),
      card_type: HubCardType.LostItem,
      chat_uuid: GRILL_110_CHAT_UUID,
      description: (mockAlertsData[GRILL_110_CHAT_UUID][0] as LostItemAlert)
        .subtitle,
      display_name: (mockAlertsData[GRILL_110_CHAT_UUID][0] as LostItemAlert)
        .display_name,
      external_item_id: (
        mockAlertsData[GRILL_110_CHAT_UUID][0] as LostItemAlert
      ).external_item_id,
      pack_unit: (mockAlertsData[GRILL_110_CHAT_UUID][0] as LostItemAlert)
        .pack_unit,
      photo_url_list: (mockAlertsData[GRILL_110_CHAT_UUID][0] as LostItemAlert)
        .photo_url_list,
      restaurant_uuid: GRILL_110_RESTAURANT_UUID,
      subtitle: createTranslation('1 District Ave, Boston, MA 02125, USA'),
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: createTranslation('110 Grill'),
      variant_pack_uuid: (
        mockAlertsData[GRILL_110_CHAT_UUID][0] as LostItemAlert
      ).variant_pack_uuid,
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_uuid: uuidv4(),
      card_type: HubCardType.LostItem,
      chat_uuid: JOHNS_SEAFOOD_HOUSE_CHAT_UUID,
      description: (
        mockAlertsData[JOHNS_SEAFOOD_HOUSE_CHAT_UUID][0] as LostItemAlert
      ).subtitle,
      display_name: (
        mockAlertsData[JOHNS_SEAFOOD_HOUSE_CHAT_UUID][0] as LostItemAlert
      ).display_name,
      external_item_id: (
        mockAlertsData[JOHNS_SEAFOOD_HOUSE_CHAT_UUID][0] as LostItemAlert
      ).external_item_id,
      pack_unit: (
        mockAlertsData[JOHNS_SEAFOOD_HOUSE_CHAT_UUID][0] as LostItemAlert
      ).pack_unit,
      photo_url_list: (
        mockAlertsData[JOHNS_SEAFOOD_HOUSE_CHAT_UUID][0] as LostItemAlert
      ).photo_url_list,
      restaurant_uuid: JOHNS_SEAFOOD_HOUSE_RESTAURANT_UUID,
      subtitle: createTranslation(
        '1326 W Girard Ave, Philadelphia, PA 19123, USA',
      ),
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: createTranslation("John's Sea Food House"),
      variant_pack_uuid: (
        mockAlertsData[JOHNS_SEAFOOD_HOUSE_CHAT_UUID][0] as LostItemAlert
      ).variant_pack_uuid,
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_uuid: uuidv4(),
      card_type: HubCardType.LostItem,
      chat_uuid: BOBS_BURGER_SHACK_CHAT_UUID,
      description: (
        mockAlertsData[BOBS_BURGER_SHACK_CHAT_UUID][0] as LostItemAlert
      ).subtitle,
      display_name: (
        mockAlertsData[BOBS_BURGER_SHACK_CHAT_UUID][0] as LostItemAlert
      ).display_name,
      external_item_id: (
        mockAlertsData[BOBS_BURGER_SHACK_CHAT_UUID][0] as LostItemAlert
      ).external_item_id,
      pack_unit: (
        mockAlertsData[BOBS_BURGER_SHACK_CHAT_UUID][0] as LostItemAlert
      ).pack_unit,
      photo_url_list: (
        mockAlertsData[BOBS_BURGER_SHACK_CHAT_UUID][0] as LostItemAlert
      ).photo_url_list,
      restaurant_uuid: BOBS_BURGER_SHACK_RESTAURANT_UUID,
      subtitle: createTranslation(
        '120 Sir Francis Drake Blvd, San Anselmo, CA 94960, USA',
      ),
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: createTranslation("Bob's Burger Shack"),
      variant_pack_uuid: (
        mockAlertsData[BOBS_BURGER_SHACK_CHAT_UUID][0] as LostItemAlert
      ).variant_pack_uuid,
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_uuid: uuidv4(),
      card_type: HubCardType.LostItem,
      chat_uuid: SPECIALTY_GOODS_CHAT_UUID,
      description: (
        mockAlertsData[SPECIALTY_GOODS_CHAT_UUID][0] as LostItemAlert
      ).subtitle,
      display_name: (
        mockAlertsData[SPECIALTY_GOODS_CHAT_UUID][0] as LostItemAlert
      ).display_name,
      external_item_id: (
        mockAlertsData[SPECIALTY_GOODS_CHAT_UUID][0] as LostItemAlert
      ).external_item_id,
      pack_unit: (mockAlertsData[SPECIALTY_GOODS_CHAT_UUID][0] as LostItemAlert)
        .pack_unit,
      photo_url_list: (
        mockAlertsData[SPECIALTY_GOODS_CHAT_UUID][0] as LostItemAlert
      ).photo_url_list,
      restaurant_uuid: SPECIALTY_GOODS_RESTAURANT_UUID,
      subtitle: createTranslation(
        '120 Sir Francis Drake Blvd, San Anselmo, CA 94960, USA',
      ),
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: createTranslation('Specialty Goods'),
      variant_pack_uuid: (
        mockAlertsData[SPECIALTY_GOODS_CHAT_UUID][0] as LostItemAlert
      ).variant_pack_uuid,
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_uuid: uuidv4(),
      card_type: HubCardType.LostItem,
      chat_uuid: GOURMET_ICE_CREAM_CHAT_UUID,
      description: (
        mockAlertsData[GOURMET_ICE_CREAM_CHAT_UUID][0] as LostItemAlert
      ).subtitle,
      display_name: (
        mockAlertsData[GOURMET_ICE_CREAM_CHAT_UUID][0] as LostItemAlert
      ).display_name,
      external_item_id: (
        mockAlertsData[GOURMET_ICE_CREAM_CHAT_UUID][0] as LostItemAlert
      ).external_item_id,
      pack_unit: (
        mockAlertsData[GOURMET_ICE_CREAM_CHAT_UUID][0] as LostItemAlert
      ).pack_unit,
      photo_url_list: (
        mockAlertsData[GOURMET_ICE_CREAM_CHAT_UUID][0] as LostItemAlert
      ).photo_url_list,
      restaurant_uuid: GOURMET_ICE_CREAM_RESTAURANT_UUID,
      subtitle: createTranslation(
        '120 Sir Francis Drake Blvd, San Anselmo, CA 94960, USA',
      ),
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: createTranslation('Gourmet Ice Cream'),
      variant_pack_uuid: (
        mockAlertsData[GOURMET_ICE_CREAM_CHAT_UUID][0] as LostItemAlert
      ).variant_pack_uuid,
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_uuid: uuidv4(),
      card_type: HubCardType.LostItem,
      chat_uuid: RYANS_RIPPIN_RESTAURANT_CHAT_UUID,
      description: (
        mockAlertsData[RYANS_RIPPIN_RESTAURANT_CHAT_UUID][0] as LostItemAlert
      ).subtitle,
      display_name: (
        mockAlertsData[RYANS_RIPPIN_RESTAURANT_CHAT_UUID][0] as LostItemAlert
      ).display_name,
      external_item_id: (
        mockAlertsData[RYANS_RIPPIN_RESTAURANT_CHAT_UUID][0] as LostItemAlert
      ).external_item_id,
      pack_unit: (
        mockAlertsData[RYANS_RIPPIN_RESTAURANT_CHAT_UUID][0] as LostItemAlert
      ).pack_unit,
      photo_url_list: (
        mockAlertsData[RYANS_RIPPIN_RESTAURANT_CHAT_UUID][0] as LostItemAlert
      ).photo_url_list,
      restaurant_uuid: RYANS_RIPPIN_RESTAURANT_RESTAURANT_UUID,
      subtitle: createTranslation('Blackcomb Wy, Whistler, BC V8E, Canada'),
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: createTranslation('Ryans Rippin Restaurant'),
      variant_pack_uuid: (
        mockAlertsData[RYANS_RIPPIN_RESTAURANT_CHAT_UUID][0] as LostItemAlert
      ).variant_pack_uuid,
    },
  ],
  cardType: HubCardType.LostItem,
};

export const dummyChurnRisks: SalesAlertsHubCardData = {
  cardData: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_uuid: (
        mockAlertsData[GENERAL_NUTRITION_CHAT_UUID][0] as ChurnRiskAlert
      ).alert_uuid,
      card_type: HubCardType.ChurnRisk,
      chat_uuid: GENERAL_NUTRITION_CHAT_UUID,
      description: (
        mockAlertsData[GENERAL_NUTRITION_CHAT_UUID][0] as ChurnRiskAlert
      ).subtitle,
      restaurant_uuid: GENERAL_NUTRITION_RESTAURANT_UUID,
      subtitle: createTranslation(
        '120 Sir Francis Drake Blvd, San Anselmo, CA 94960, USA',
      ),
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: createTranslation('General Nutrition'),
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_uuid: (mockAlertsData[TINA_TUNA_CHAT_UUID][0] as ChurnRiskAlert)
        .alert_uuid,
      card_type: HubCardType.ChurnRisk,
      chat_uuid: TINA_TUNA_CHAT_UUID,
      description: (mockAlertsData[TINA_TUNA_CHAT_UUID][0] as ChurnRiskAlert)
        .subtitle,
      restaurant_uuid: TINA_TUNA_RESTAURANT_UUID,
      subtitle: createTranslation(
        '125 Redpath Ave, Toronto, ON M4S 0B5, Canada',
      ),
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: createTranslation("Tina's Tuna"),
    },
  ],
  cardType: HubCardType.ChurnRisk,
};

export const dummyHiddenAlerts: HubCardData[] = [
  ...(dummyChurnRisks.cardData.map((cardData: ChurnRiskHubCardData) => ({
    ...cardData,
    alert_status: AnalyticsAlertStatusType.Hidden,
    card_type: HubCardType.ChurnRisk,
  })) as HubCardData[]),
  ...(dummyLostItems.cardData.map((cardData: LostItemHubCardData) => ({
    ...cardData,
    alert_status: AnalyticsAlertStatusType.Hidden,
    card_type: HubCardType.LostItem,
  })) as HubCardData[]),
  ...(dummyOverduePayments.cardData.map(
    (cardData: OverduePaymentHubCardData) => ({
      ...cardData,
      alert_status: AnalyticsAlertStatusType.Hidden,
      card_type: HubCardType.OverduePayment,
      currency_code: 'USD',
    }),
  ) as HubCardData[]),
];

// =============================================================================
// Bronco Demo Hub Card Data (DSR-3748)
// =============================================================================

/**
 * Transforms mockAlertsData entries for all Bronco demo accounts into
 * HubCardData format grouped by card type, for use in the FYP / Insights Hub.
 */
const buildBroncoHubCards = (): {
  active: SalesAlertsHubCardData[];
  hidden: HubCardData[];
} => {
  const lostItems: LostItemHubCardData[] = [];
  const churnRisks: ChurnRiskHubCardData[] = [];
  const overduePayments: OverduePaymentHubCardData[] = [];

  for (const chatUUID of BRONCO_DEMO_CHATS) {
    const alerts = mockAlertsData[chatUUID];
    const meta = BRONCO_DEMO_RESTAURANT_META[chatUUID];

    if (!alerts?.length || !meta) {
      continue;
    }

    const title = createTranslation(meta.name);
    const subtitle = createTranslation(meta.address);

    for (const alert of alerts) {
      switch (alert.alert_type) {
        case AnalyticsAlertType.LostItem: {
          lostItems.push({
            alert_status: AnalyticsAlertStatusType.Active,
            alert_uuid: alert.alert_uuid,
            card_type: HubCardType.LostItem,
            chat_uuid: chatUUID,
            description: alert.subtitle,
            display_name: alert.display_name,
            external_item_id: alert.external_item_id,
            pack_unit: alert.pack_unit,
            photo_url_list: alert.photo_url_list,
            restaurant_uuid: meta.restaurantUUID,
            subtitle,
            supplier_uuid: BRONCO_SUPPLIER_UUID,
            title,
            variant_pack_uuid: alert.variant_pack_uuid,
          });
          break;
        }
        case AnalyticsAlertType.ChurnRisk: {
          churnRisks.push({
            alert_status: AnalyticsAlertStatusType.Active,
            alert_uuid: alert.alert_uuid,
            card_type: HubCardType.ChurnRisk,
            chat_uuid: chatUUID,
            description: alert.subtitle,
            restaurant_uuid: meta.restaurantUUID,
            subtitle,
            supplier_uuid: BRONCO_SUPPLIER_UUID,
            title,
          });
          break;
        }
        case AnalyticsAlertType.OverduePayment: {
          if (alert.data?.[0]) {
            overduePayments.push({
              alert_status: AnalyticsAlertStatusType.Active,
              alert_uuid: alert.data[0].alert_uuid,
              amount: alert.data[0].amount,
              card_type: HubCardType.OverduePayment,
              chat_uuid: chatUUID,
              currency_code: 'USD',
              description: alert.subtitle,
              invoice_number: alert.data[0].invoice_number,
              order_invoice_uuid: alert.data[0].order_invoice_uuid,
              overdue_by_text: alert.subtitle,
              restaurant_uuid: meta.restaurantUUID,
              subtitle,
              supplier_uuid: BRONCO_SUPPLIER_UUID,
              title,
            });
          }
          break;
        }
      }
    }
  }

  const active: SalesAlertsHubCardData[] = [];
  if (lostItems.length > 0) {
    active.push({ cardData: lostItems, cardType: HubCardType.LostItem });
  }
  if (churnRisks.length > 0) {
    active.push({ cardData: churnRisks, cardType: HubCardType.ChurnRisk });
  }
  if (overduePayments.length > 0) {
    active.push({
      cardData: overduePayments,
      cardType: HubCardType.OverduePayment,
    });
  }

  const allActiveCards: HubCardData[] = [
    ...(lostItems as HubCardData[]),
    ...(churnRisks as HubCardData[]),
    ...(overduePayments as HubCardData[]),
  ];

  const hidden: HubCardData[] = allActiveCards.map((card) => ({
    ...card,
    alert_status: AnalyticsAlertStatusType.Hidden,
  }));

  return { active, hidden };
};

const broncoHubCards = buildBroncoHubCards();

export const broncoDemoActiveAlerts = broncoHubCards.active;
export const broncoDemoHiddenAlerts = broncoHubCards.hidden;
